<template>
  <div class="gallery-section">
    <div
      ref="imageWrapper"
      class="image-wrapper"
      :class="positionClass"
      @click.self="resetGallery"
    >
      <ImageCard
        v-for="(image, index) in images"
        :key="image.id"
        :image="image"
        :index="index"
        :fontType="fontType"
        :class="getImageClass(index)"
        @hover="handleImageHover"
        @leave="handleImageLeave"
      />
    </div>
  </div>
</template>

<script>
import ImageCard from './ImageCard.vue'

export default {
  name: 'ImageGallery',

  props: {
    images: {
      type: Array,
      required: true,
    },
    fontType: {
      type: String,
      required: true
    },
  },

  components: {
    ImageCard
  },

  data() {
    return {
      currentHovered: -1,
      currentPosition: 0
    }
  },

  computed: {
    positionClass() {
      const positions = ['hover-first', 'hover-second', 'hover-third', 'hover-fourth']
      return positions[this.currentPosition] || 'hover-first'
    }
  },

  methods: {
    handleImageHover(index) {
      this.currentHovered = index
      const imageCount = this.images.length
      if (index === imageCount - 1) {
        this.currentPosition = imageCount - 1
      } else {
        this.currentPosition = index
      }
    },

    handleImageLeave() {
      this.currentHovered = -1
    },

    resetGallery() {
      this.currentHovered = -1
      this.currentPosition = 0
    },

    getImageClass(index) {
      if (this.currentHovered === -1) return ''

      if (index === this.currentHovered) {
        return 'hovered'
      } else {
        const distance = Math.abs(index - this.currentHovered)
        return distance === 1 ? 'adjacent' : 'distant'
      }
    },

    handleClickOutside(event) {
      if (this.$refs.imageWrapper && !this.$refs.imageWrapper.contains(event.target)) {
        this.resetGallery()
      }
    }
  },

  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },

  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style scoped>
.gallery-section {
  overflow: hidden;
  border-radius: 15px;
  height: 480px;
  /* min-height: 500px; */
  padding: 1.5rem;
}

.image-wrapper {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  position: relative;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.hover-first {
  transform: translateX(0);
}

.hover-second {
  /* transform: translateX(-12.5%); */
  transform: translateX(-7.5%);
  /* transform: translateX(-17%); */
}

.hover-third {
  /* transform: translateX(-25%); */
  transform: translateX(-15%);
  /* transform: translateX(-34%); */
}

.hover-fourth {
  /* transform: translateX(-37.5%); */
  transform: translateX(-22.5%);
  /* transform: translateX(-51%); */
}

:deep(.hovered) {
  transform: scale(1.10);
  z-index: 10;
}

:deep(.adjacent) {
  transform: scale(0.95);
  opacity: 0.7;
}

:deep(.distant) {
  transform: scale(0.9);
  opacity: 0.4;
}

@media (max-width: 768px) {
  .gallery-section {
    min-height: 300px;
    margin-top: 2rem;
  }

  .hover-first {
    transform: translateX(0);
  }

  .hover-second {
    /* transform: translateX(-12.5%); */
    transform: translateX(-75%);
  }

  .hover-third {
    /* transform: translateX(-25%); */
    transform: translateX(-150%);
  }

  .hover-fourth {
    /* transform: translateX(-37.5%); */
    transform: translateX(-225%);
  }
}
</style>
